import React from "react";
import { Check } from "lucide-react";

const points = [
    {
        title: "Less manual searching.",
        body: "Search by area and category instead of opening each website manually from scratch.",
    },
    {
        title: "Cleaner lead lists.",
        body: "Duplicate handling, domain grouping, suppression checks, and email quality filters.",
    },
    {
        title: "Better follow-up context.",
        body: "Saved searches, send history, contact-form outcomes, and diagnostics in one place.",
    },
    {
        title: "You keep delivery control.",
        body: "Send through your own SMTP provider — not a shared bulk-sending platform.",
    },
];

export default function Benefits() {
    return (
        <section
            data-testid="benefits-section"
            className="border-b border-border bg-bg"
        >
            <div className="mx-auto max-w-[1440px] grid lg:grid-cols-2 lg:gap-0">
                <div className="relative border-b lg:border-b-0 lg:border-r border-border">
                    <div className="p-6 md:p-12 lg:p-16">
                        <span className="overline">FIG.02 — Activity timeline</span>
                        <div className="mt-6 border border-ink bg-surface shadow-[8px_8px_0_0_hsl(var(--ink))]">
                            <img
                                data-testid="benefits-image"
                                src="/assets/screenshots/reachforge-leads-activity-timeline.svg"
                                alt="Activity timeline view in ReachForge"
                                className="block w-full h-auto"
                                loading="lazy"
                            />
                        </div>
                    </div>
                </div>
                <div className="p-6 md:p-12 lg:p-16 flex flex-col justify-center">
                    <span className="overline">Why it helps</span>
                    <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mt-4 leading-[1.05] text-ink">
                        Move from a market idea to a real outreach pipeline.
                    </h2>
                    <div className="mt-10 space-y-px bg-border border border-border">
                        {points.map((p, i) => (
                            <div
                                key={p.title}
                                data-testid={`benefit-${i + 1}`}
                                className="bg-bg flex gap-4 p-5 md:p-6"
                            >
                                <div className="h-7 w-7 shrink-0 border border-ink flex items-center justify-center bg-ink text-bg">
                                    <Check size={14} strokeWidth={3} />
                                </div>
                                <div>
                                    <div className="font-display text-lg font-semibold text-ink">
                                        {p.title}
                                    </div>
                                    <div className="text-ink-soft mt-1">
                                        {p.body}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <p className="mt-8 text-sm text-ink-mute max-w-md">
                        <span className="font-semibold text-ink">
                            Responsible-use note.
                        </span>{" "}
                        Built around suppression lists, unsubscribe handling,
                        and privacy notices. Users remain responsible for
                        applicable email, privacy, and marketing rules.
                    </p>
                </div>
            </div>
        </section>
    );
}
